/**
 * LQIP - Low Quality Image Placeholder
 * Handles image load detection and placeholder fade-out
 */
(function () {
  'use strict';

  function log() {}

  function markAsLoaded(wrapper, reason) {
    if (wrapper.classList.contains('is-loaded')) {
      return;
    }
    log('Marking as loaded:', reason, wrapper);
    wrapper.classList.add('is-loaded');
  }

  function checkImageLoaded(img) {
    var loaded = img.complete && img.naturalWidth > 0;
    log('Check image loaded:', loaded, 'complete:', img.complete, 'naturalWidth:', img.naturalWidth, 'src:', img.src.substring(0, 80));
    return loaded;
  }

  function initLQIP() {
    var wrappers = document.querySelectorAll(
      '.hab-lqip-wrapper:not(.is-initialized)'
    );

    log('initLQIP called, found', wrappers.length, 'uninitialized wrappers');

    wrappers.forEach(function (wrapper, index) {
      wrapper.classList.add('is-initialized');

      var fullImage = wrapper.querySelector('.hab-lqip-full');
      if (!fullImage) {
        log('Wrapper', index, '- no .hab-lqip-full found');
        return;
      }

      log('Wrapper', index, '- found full image:', fullImage.src.substring(0, 80));

      // Check if image is already loaded (cached)
      if (checkImageLoaded(fullImage)) {
        markAsLoaded(wrapper, 'already loaded/cached');
        return;
      }

      // Listen for load event
      fullImage.addEventListener('load', function () {
        log('Load event fired for:', fullImage.src.substring(0, 80));
        markAsLoaded(wrapper, 'load event');
      });

      // Handle error
      fullImage.addEventListener('error', function () {
        log('Error event fired for:', fullImage.src.substring(0, 80));
        var placeholder = wrapper.querySelector('.hab-lqip-placeholder');
        if (!placeholder) {
          return;
        }
        placeholder.style.filter = 'none';
        placeholder.style.transform = 'none';
      });

      // Double-check after delays in case load event was missed
      setTimeout(function () {
        if (checkImageLoaded(fullImage)) {
          markAsLoaded(wrapper, 'setTimeout 100ms');
        }
      }, 100);

      setTimeout(function () {
        if (checkImageLoaded(fullImage)) {
          markAsLoaded(wrapper, 'setTimeout 500ms');
        }
      }, 500);

      setTimeout(function () {
        if (checkImageLoaded(fullImage)) {
          markAsLoaded(wrapper, 'setTimeout 1000ms');
        }
      }, 1000);
    });
  }

  log('Script loaded, readyState:', document.readyState);

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    log('Adding DOMContentLoaded listener');
    document.addEventListener('DOMContentLoaded', function () {
      log('DOMContentLoaded fired');
      initLQIP();
    });
  } else {
    log('DOM already ready, calling initLQIP immediately');
    initLQIP();
  }

  // Also run on window load to catch any missed images
  window.addEventListener('load', function () {
    log('Window load fired');
    initLQIP();
  });

  // Re-initialize for dynamically added content (Shopify section rendering)
  document.addEventListener('shopify:section:load', function () {
    log('shopify:section:load fired');
    initLQIP();
    initVideoLQIP();
  });

  // Initialize video LQIP (for video poster placeholders)
  function initVideoLQIP() {
    var videoWrappers = document.querySelectorAll(
      '.hab-video-lqip-wrapper:not(.is-initialized)'
    );

    log('initVideoLQIP called, found', videoWrappers.length, 'uninitialized video wrappers');

    videoWrappers.forEach(function (wrapper, index) {
      wrapper.classList.add('is-initialized');

      var video = wrapper.querySelector('video');
      if (!video) {
        log('Video wrapper', index, '- no video found');
        return;
      }

      log('Video wrapper', index, '- found video');

      // Check if video can play (loadeddata event)
      video.addEventListener('loadeddata', function () {
        log('Video loadeddata event fired');
        wrapper.classList.add('is-loaded');
      });

      video.addEventListener('canplay', function () {
        log('Video canplay event fired');
        wrapper.classList.add('is-loaded');
      });

      // If video is already ready
      if (video.readyState >= 2) {
        log('Video already ready, readyState:', video.readyState);
        wrapper.classList.add('is-loaded');
      }

      // Fallback timeout
      setTimeout(function () {
        if (video.readyState >= 2) {
          log('Video ready after timeout');
          wrapper.classList.add('is-loaded');
        }
      }, 500);
    });
  }

  // Run video LQIP init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoLQIP);
  } else {
    initVideoLQIP();
  }
  window.addEventListener('load', initVideoLQIP);

  // Expose for manual initialization
  window.initLQIP = initLQIP;
  window.initVideoLQIP = initVideoLQIP;
})();
